import campStyles from './Campaigns.module.css';

export const CAMPAIGN_STATUS_LABELS: Record<string, string> = {
  draft: 'Concept',
  running: 'Actief',
  paused: 'Gepauzeerd',
  completed: 'Afgerond',
};

export const EXPERIMENT_STATUS_LABELS: Record<string, string> = {
  collecting: 'Data verzamelen',
  not_significant: 'Nog geen verschil',
  significant: 'Significant',
  inconclusive: 'Onbeslist',
};

export function campaignStatusClass(status: string): string {
  if (status === 'running') return campStyles.statusRunning;
  if (status === 'paused') return campStyles.statusPaused;
  if (status === 'completed') return campStyles.statusCompleted;
  return campStyles.statusDraft;
}

export function formatPct(rate: number | null | undefined, digits = 1): string {
  if (rate == null || !Number.isFinite(rate)) return '—';
  return `${(rate * 100).toFixed(digits)}%`;
}

export function formatSendWindow(start?: number, end?: number): string {
  const a = start ?? 9;
  const b = end ?? 17;
  return `${String(a).padStart(2, '0')}:00–${String(b).padStart(2, '0')}:00`;
}
